import request from './request'

// 用户列表查询（分页）
export function getUserList (params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

// 新增用户
export function addUser (data) {
  return request({
    url: '/admin/user/add',
    method: 'post',
    data
  })
}

// 编辑用户
export function updateUser (data) {
  return request({
    url: '/admin/user/update',
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser (id) {
  return request({
    url: `/admin/user/delete/${id}`,
    method: 'delete'
  })
}

// 重置用户密码
export function resetPassword (data) {
  return request({
    url: '/admin/user/resetPassword',
    method: 'put',
    data
  })
}

// 用户修改密码（校验旧密码）
export function changePassword (data) {
  return request({
    url: '/admin/user/changePassword',
    method: 'put',
    data
  })
}

// 下载用户导入模板
export function downloadUserImportTemplate () {
  return request({
    url: '/admin/user/import/template',
    method: 'get',
    responseType: 'blob'
  })
}

// 批量导入用户
export function importUsers (formData) {
  return request({
    url: '/admin/user/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 禁用用户
export function disableUser (id) {
  return request({
    url: `/admin/user/disable/${id}`,
    method: 'put'
  })
}
